'use client'

import { useState } from 'react'
import { MapPin } from 'lucide-react'

const MAP_SRC =
  'https://maps.google.com/maps?q=Michigan%20Aviation%2C%206150%20Highland%20Rd%2C%20Waterford%20Township%2C%20MI%2048327&t=&z=13&ie=UTF8&iwloc=&output=embed'

const TITLE =
  'Map showing Michigan Aviation at Oakland County International Airport (KPTK) in Waterford Township, Michigan'

/**
 * Click-to-load Google Maps embed.
 *
 * The live embed pulls ~900KB across several third-party requests and sets
 * cookies before the user has asked for a map. We render a lightweight
 * placeholder in the same box and only mount the iframe on interaction, so the
 * map costs nothing on first load.
 */
export function MapEmbed() {
  const [loaded, setLoaded] = useState(false)

  if (loaded) {
    return (
      <iframe
        title={TITLE}
        src={MAP_SRC}
        className="absolute inset-0 h-full w-full"
        style={{ border: 0, minHeight: '320px' }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    )
  }

  return (
    <button
      type="button"
      onClick={() => setLoaded(true)}
      aria-label="Load interactive map of Michigan Aviation at Oakland County International Airport"
      className="group absolute inset-0 h-full w-full bg-secondary flex flex-col items-center justify-center gap-3 transition-colors hover:bg-secondary/70"
      style={{ minHeight: '320px' }}
    >
      {/* Subtle street-grid suggestion so the placeholder reads as a map */}
      <span
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />
      <MapPin className="relative h-8 w-8 text-accent" strokeWidth={1.5} />
      <span className="relative text-sm font-medium text-foreground">
        Oakland County International Airport (KPTK)
      </span>
      <span className="relative text-xs text-muted-foreground">
        6150 Highland Rd, Waterford Township, MI 48327
      </span>
      <span className="relative mt-2 text-xs font-medium text-accent underline underline-offset-4 group-hover:no-underline">
        Load interactive map
      </span>
    </button>
  )
}
